import { type FC } from 'react';

import { getOffer } from '../../../../shared/helpers';
import { BaseOfferStep } from '../../../steps/OfferStep/BaseOfferStep';
import { useOfferStepLogic } from '../../../steps/OfferStep/useOfferStepLogic';
import { useDefaultContractTypePreSelection } from '../../exp-n-611/hooks/useDefaultContractTypePreSelection';
import { OfferCard } from '../components/OfferCard_B';
import { RibbonHeightSyncProvider } from '../components/useRibbonHeightSync';
import { TitleHeightSyncProvider } from '../components/useTitleHeightSync';

export const OfferStep: FC = () => {
  const logic = useOfferStepLogic({
    buildSubmitPayload: ({ selectedDiscountCode, flowContext, offer }) => {
      const selectedOffer = getOffer({ ...flowContext, discountCode: selectedDiscountCode }, offer);

      return {
        offerType: selectedOffer?.discountType,
      };
    },
  });

  // exp-n-611 — default contract type. Acquisition offer step only (not the extension flow).
  // Delete this call (and the exp-n-611 folder) to remove the experiment.
  useDefaultContractTypePreSelection({
    isSuccessful: logic.isSuccessful,
    offers: logic.offers,
    selectedDiscountCode: logic.selectedDiscountCode,
    handleValueChange: logic.handleValueChange,
  });

  return (
    <TitleHeightSyncProvider>
      <RibbonHeightSyncProvider>
        <BaseOfferStep
          logic={logic}
          listItemsGap="3"
          renderOfferCard={offer => (
            <OfferCard
              key={offer.type}
              isOpen={logic.isPriceDetailsOpen}
              setOpen={logic.setIsPriceDetailsOpen}
              isSelected={offer.type === logic.selectedDiscountCode}
              onSelect={() => {
                if (!offer.type) return;
                logic.setValue('discountCode', offer.type, { shouldValidate: true, shouldDirty: true });
              }}
              offer={offer}
              textualData={logic.textualData}
              flowContext={logic.flowContext}
              energyType={logic.energyType}
            />
          )}
        />
      </RibbonHeightSyncProvider>
    </TitleHeightSyncProvider>
  );
};
